import { useEffect, useState } from "react";
import { Warning, X } from "@phosphor-icons/react";

export default function BudgetBanner() {
    const [msg, setMsg] = useState(null);

    useEffect(() => {
        const onEvt = (e) => setMsg(e.detail || "AI credit balance exhausted.");
        window.addEventListener("counseliq:budget-exhausted", onEvt);
        return () => window.removeEventListener("counseliq:budget-exhausted", onEvt);
    }, []);

    if (!msg) return null;

    return (
        <div
            data-testid="budget-banner"
            className="sticky top-0 z-30 bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-2.5 flex items-start gap-3"
        >
            <Warning size={18} weight="fill" className="shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0 text-sm">
                <div className="font-semibold">AI credit balance exhausted</div>
                <div className="text-xs leading-relaxed mt-0.5">
                    {msg} {" "}
                    Open <span className="font-mono bg-white/60 px-1 rounded-sm">Profile → Universal Key → Add Balance</span> in your Emergent dashboard,
                    or enable auto top-up. Drafts, research, and document Q&amp;A will resume immediately after a top-up.
                </div>
            </div>
            <button
                onClick={() => setMsg(null)}
                className="shrink-0 rounded-sm hover:bg-white/40 p-1"
                aria-label="Dismiss"
                data-testid="budget-banner-dismiss"
            >
                <X size={14} />
            </button>
        </div>
    );
}
